export default function ConditionallyRender({ when = false, children }) {
    if (when) {
        return children
    }
    return null
}
